<template>
    <v-ons-page>

        <!-- 120px is the height of the .outlet-header-logo-->
        <img v-if="outlet && outlet.logo_image && show_header_image && helpers.stringEmpty(outlet.logo_image) == false"
                            class="outlet-header-logo"
                             v-bind:src="outlet.logo_image" v-bind:style="{'top': `calc(100% / 4 - 120px / 2 - ${scroll_position}px)`}">

        <ons-toolbar class="main-toolbar branded" ref="main-toolbar"
                    :class="{'small-header': !(has_header_image && show_header_image)}" 
                    v-bind:style="{'height': has_header_image && show_header_image ? `calc(100% / 4 - ${scroll_position}px)` : '56px'}">

            <img v-show="outlet && outlet.header_image && show_header_image && helpers.stringEmpty(outlet.header_image) == false" 
                            class="outlet-header-image"
                            :src="outlet ? outlet.header_image : ''"
                            :style="{'opacity': `calc(1 - ${scroll_position} / 150)`}">

            <div class="left">
                <v-ons-toolbar-button v-on:click="sidebarToggle" v-if="embed.enabled || orderLoadedDirectly"
                                      class="icon-bar" data-test-id="btn-sidebar">
                    <i class="fal fa-bars"></i>
                </v-ons-toolbar-button>
                <router-link v-bind:to="{ name: 'Outlets' }" title="Outlets" v-else data-test-id="btn-back">
                    <svg class="icon icon-back" aria-hidden="true"></svg>
                </router-link>
            </div>
            <div v-show="!(show_header_image)" class="center">
                <div class="outlet-navbar">
                    <span class="outlet-store-name">{{ outlet ? outlet.store_display_name : '' }}</span>
                </div>
            </div>
            <div class="right basket" v-show="outlet" data-test-id="btn-basket">
                <template v-if="browse_only">
                    <svg class="icon-basket" aria-hidden="true" v-on:click="handleBrowseInteract"/>
                </template>
                <router-link v-else v-show="basketInfo.has_items" v-bind:to="{ name: 'CreateOrder' }" v-bind:class=" { boing: basket_flash }">
                    <svg class="icon-basket" aria-hidden="true"></svg>
                </router-link>
            </div>
        </ons-toolbar>

        <div class="content" v-on:scroll="listScrolled" v-on:ontouchmove="listScrolled" v-bind:style="{'top': has_header_image && show_header_image ? `calc(100% / 4 - ${scroll_position}px)` : (has_header_image ? '56px' : '0px')}">

            <v-ons-progress-bar v-if="show_loading" indeterminate/>

            <div class="content-inner" v-if="outlet">

                <div class="outlet-container mb-10">
                    <div class="outlet-name-header">
                        {{ outlet.store_display_name }}
                    </div>
                    <div class="outlet-desc-text pressable" v-show="helpers.stringEmpty(outlet.outlet_desc) == false" @click="() => description_collapsed = !description_collapsed">
                        <vue-clamp class="line-breaks" autoresize :max-lines="description_collapsed ? 4: null">{{ outlet.outlet_desc }}</vue-clamp>
                    </div>
                    <div class="outlet-tag-text mt-5">
                        {{ outlet.opening_times_info.status }}
                    </div>
                    <div class="outlet-tag-text mt-5">
                        <template v-if="outlet.tags.length > 0">
                            {{ outlet_tags.join(' • ') }}
                        </template>
                        <template v-else>
                            No tags
                        </template>
                    </div>
                    <div class="outlet-tag-text mt-5">
                        {{ outlet.order_fulfillment_type_names.join(' • ') }}
                    </div>
                </div>

                <div class="outlet-info-btns" v-on:click="$router.push({ name: 'Outlet' })">
                    <div class="outlet-info-btn" v-if="outlet.prep_time_minutes_min > 0">
                        <gtc-button class="tertiary small" icon="fal fa-shopping-basket">
                            ~{{ helpers.outletPrepTimeShort(outlet.prep_time_minutes_min) }}
                        </gtc-button>
                    </div>
                    <div class="outlet-info-btn">
                        <gtc-button class="tertiary small" v-if="outlet.opening_times_info" icon="fal fa-clock">
                            {{ outlet.opening_times_info.is_open ? 'Open' : 'Closed' }}
                        </gtc-button>
                    </div>
                    <div class="outlet-info-btn">
                           <gtc-button class="col-xs-4 tertiary small" icon="fal fa-info-circle">
                            More info
                        </gtc-button>
                    </div>
                </div>

                <div ref="scroll-target"/>

                <div v-if="outlet.multivendor_supported" class="prompt-multivendor">
                    <span>{{ outlet.store_display_name }} is part of {{ outlet.multivendor_controller_outlet.store_display_name }}</span>
                    <gtc-button class="btn-action branded" data-test-id="href-multivendor-controller"
                        v-on:click="navigateToOutlet(outlet.multivendor_controller_outlet.slug)">
                            View more items in {{ outlet.multivendor_controller_outlet.store_display_name }}
                    </gtc-button>
                </div>

                <div v-show="order.menu_option == null">

                    <!-- Fulfillment selector if > 1 option -->
                    <div v-show="menu_option.fulfillment_type == null" class="section-h">

                        <v-ons-list>
                            <v-ons-list-item>
                                <div class="center">
                                    <div class="sub-header">Select an order type</div>
                                    <div class="fulfillment-type-container">
                                        <div id="btn-collection" class="fulfillment-btn" data-test-id="btn-collection"
                                            v-if="outlet.order_fulfillment_types.COLLECTION"
                                            v-on:click="setFulfillmentType('COLLECTION')"
                                            v-bind:class="{ active: menu_option.fulfillment_type == 'COLLECTION' }">
                                            <div>
                                                <span>
                                                    <i class="fa fa-check" aria-hidden="true"></i>
                                                </span>
                                                <svg class="icon-collection"/>
                                                <div class="fulfillment-text">Collection</div>
                                            </div>
                                        </div>
                                        <div id="btn-delivery" class="fulfillment-btn" data-test-id="btn-delivery"
                                            v-if="outlet.order_fulfillment_types.DELIVERY"
                                            v-on:click="setFulfillmentType('DELIVERY', outlet.order_fulfillment_types.DELIVERY)"
                                            v-bind:class="{ active: menu_option.fulfillment_type == 'DELIVERY' }">
                                            <div>
                                                <span>
                                                    <i class="fa fa-check" aria-hidden="true"></i>
                                                </span>
                                                <svg class="icon-delivery"/>
                                                <div class="fulfillment-text">Delivery</div>
                                            </div>
                                        </div>
                                        <div id="btn-dropoff" class="fulfillment-btn" data-test-id="btn-dropoff"
                                            v-if="outlet.order_fulfillment_types.DROPOFF"
                                            v-on:click="setFulfillmentType('DROPOFF')"
                                            v-bind:class="{ active: menu_option.fulfillment_type == 'DROPOFF' }">
                                            <div>
                                                <span>
                                                    <i class="fa fa-check" aria-hidden="true"></i>
                                                </span>
                                                <svg class="icon-dropoff"/>
                                                <div class="fulfillment-text">{{ outlet.dropoff_label }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-ons-list-item>
                        </v-ons-list>
                    </div>

                    <!-- Show selected fulfillment type if only one option -->
                    <div class="section-h sub-header txt-ordering" v-if="menu_option.fulfillment_type_name && has_multiple_fulfillment_types == false">
                        Ordering for {{ menu_option.fulfillment_type_name.toLowerCase() }}
                    </div>

                    <!-- Menu selector, only show if 0 or > 1 option -->
                    <template v-if="this.menu_option.fulfillment_type && this.menu_option.display_layout == null">
                        <v-ons-list class="section-h">
                            <v-ons-list-item>
                                <div class="sub-header">Select a menu</div>
                            </v-ons-list-item>
                            <v-ons-list-item v-show="filtered_display_layouts.length == 0">
                                <div class="center">
                                    No menus available for {{ menu_option.fulfillment_type_name.toLowerCase() }} - please choose another order type.
                                </div>
                            </v-ons-list-item>
                            <v-ons-list-item modifier="chevron" tappable v-for="display_layout in filtered_display_layouts"
                                             @click="setDisplayLayout(display_layout)" v-bind:key="display_layout.id"
                                             v-if="filtered_display_layouts.length > 1">
                                <div class="left">
                                    <img v-if="display_layout.image" class="item-image" v-bind:src="display_layout.image">
                                </div>
                                <div class="center">
                                    <span class="list-item__title">
                                        {{ display_layout.display_name }}
                                    </span>
                                    <span class="list-item__subtitle">
                                        <template v-if="helpers.stringEmpty(display_layout.description) == false">
                                            {{ display_layout.description }}<br>
                                        </template>
                                        {{ display_layout.opening_times_info.status }}
                                        <template v-if="display_layout.opening_times_info.is_open == false">
                                            - next available {{ display_layout.opening_times_info.next_open }}
                                        </template>
                                    </span>
                                </div>
                                <div class="right"></div>
                            </v-ons-list-item>
                            <v-onst-list-item v-show="filtered_display_layouts.length == 1">
                                <div class="center">
                                    Loading {{ filtered_display_layouts[0].display_name }}
                                    <v-ons-progress-circular indeterminate class="loading-spinner"/>
                                </div>
                            </v-onst-list-item>
                        </v-ons-list>
                    </template>

                </div>

                <template v-if="order.menu_option">

                    <div class="menu-container" data-test-id="cnt-products">
                        <div class="sticky-container" ref="sticky-container" v-bind:style="sticky_container_style"
                             v-bind:class="{ 'sticky-container-stuck': search_bar_fixed }">
                            <v-ons-list v-if="show_menu_option_bar">
                                <v-ons-list-header class="header-alert header-alert-service branded header-danger">
                                    Ordering for {{ order.menu_option.fulfillment_type_name }}
                                        <template v-if="has_multiple_menus">
                                            - {{ order.menu_option.display_layout.display_name }}
                                        </template>
                                    <br>
                                    <template v-if="outlet.opening_times_info.can_order_now == false">
                                        <small>{{ outlet.opening_times_info.status }}</small>
                                    </template>
                                    <template v-else>
                                        <small>{{ order.menu_option.display_layout.opening_times_info.status }}</small>
                                    </template>
                                    <span class="header-alert-btnchange pressable" @click="changeMenuOption()">Change</span>
                                </v-ons-list-header>
                            </v-ons-list>
                            <open-warning v-show="show_menu_option_bar == false"></open-warning>
                            <v-ons-search-input
                                class="menu-search"
                                placeholder="Search for an item or category"
                                v-model="menu_query">
                            </v-ons-search-input>
                        </div>

                        <div class="spacer" v-bind:style="{ marginTop: menu_list_top_spacer_height + 'px' }"></div>

                        <v-ons-list class="menu-list" v-if="filtered_menu.length == 0">
                            <v-ons-list-header>No items found</v-ons-list-header>
                        </v-ons-list>

                        <!-- Product categories -->
                        <template v-for="(inner_outlet, i) in outlet.outlets">

                            <!-- Store title -->
                            <v-ons-list class="section-h" v-bind:data-test-id="`cnt-outlet-${inner_outlet.slug}`">
                                <div class="inner-outlet-header"
                                     v-show="outlet.multivendor_controller" @click="outletClicked(inner_outlet)"
                                     v-bind:class="{
                                           'collapse-toggle': true,
                                           'inner-outlet-header-unavailable': inner_outlet.enabled == false,
                                           'toggle-collapsed': outlets_collapsed[inner_outlet.id],
                                    }">
                                    <img v-if="helpers.stringEmpty(inner_outlet.logo_image) == false"
                                         class="inner-outlet-header-image"
                                         v-bind:src="inner_outlet.logo_image">
                                    <div class="inner-outlet-header-container">
                                        <span class="inner-outlet-header-title">{{ inner_outlet.store_display_name }}</span>
                                        <vue-clamp v-if="inner_outlet.enabled" class="line-breaks" autoresize :max-lines="3">{{ inner_outlet.outlet_desc }}</vue-clamp>
                                        <span v-if="inner_outlet.enabled == false" class="warning-text">Ordering currently unavailable</span>
                                    </div>
                                    <svg v-show="outlet.outlets.length > 1 && inner_outlet.enabled" height="32px" width="64px" viewBox="0 0 64 32" class="opener-arrow">
                                        <line x1="1" y1="1" x2="32" y2="30" style="stroke-width:5" />
                                        <line x1="30" y1="30" x2="63" y2="1" style="stroke-width:5" />
                                    </svg>
                                </div>
                            </v-ons-list>

                            <!-- Inner outlet.
                                 Show if:
                                 - Single vendor
                                 - Multi vendor and enabled or selected
                            -->
                            <div v-if="outlet.outlets.length == 1 || (inner_outlet.enabled && selected_outlet_index == inner_outlet.id)"
                                 v-bind:class="{
                                    'collapseable': true,
                                    'collapsed': outlets_collapsed[inner_outlet.id],
                                }">

                                <!-- Alerts -->
                                <v-ons-list class="allergy-warning list-no-divider" v-show="inner_outlet.show_allergy_warnings">
                                    <allergy-warning-list-item
                                            v-bind:phone="inner_outlet.phone_no"
                                            v-bind:message="inner_outlet.allergy_message"
                                            v-bind:link="inner_outlet.allergy_link"/>
                                    <v-ons-list-item v-if="inner_outlet.supports_promotions && inner_outlet.promotions.length > 0"
                                                     modifier="chevron" v-on:click="showPromotions(inner_outlet)">
                                        <span class="prompt-text pressable">
                                            <i class="fal fa-money-bill-wave" aria-hidden="true"></i>
                                            {{ inner_outlet.promotions.length }} {{ filters.pluralise(inner_outlet.promotions.length, 'offer') }} available
                                        </span>
                                    </v-ons-list-item>
                                </v-ons-list>

                                <!-- Product list -->
                                <div v-for="(category, category_index) in filtered_menu[inner_outlet.id]"
                                     :key="`${inner_outlet.id}-${category_index}-${i}`"
                                     v-show="category.items.length > 0">
                                    <v-ons-list>
                                        <v-ons-list-header v-on:click="categoryClicked(category_index, inner_outlet)"
                                                           v-bind:class="{
                                                               'collapse-toggle': collapse_menu,
                                                               'toggle-collapsed': categories_collapsed[`${inner_outlet.id}-${category_index}`]
                                                           }"
                                                           class="header-category branded"
                                                           v-bind:ref="`category_${inner_outlet.id}_${category_index}`"
                                                           modifier="chevron">
                                            <div class="header-category-container">
                                                <span class="header-category-text">
                                                    {{ category.title }} ({{ category.items.length }})
                                                    <svg v-show="inner_outlet.collapse_menu_categories" height="32px" width="64px" viewBox="0 0 64 32" class="opener-arrow">
                                                      <line x1="1" y1="1" x2="32" y2="30" style="stroke-width:5" />
                                                      <line x1="30" y1="30" x2="63" y2="1" style="stroke-width:5" />
                                                    </svg>
                                                </span>
                                                <span class="header-category-description" v-show="helpers.stringEmpty(category.description) == false">
                                                    <br>
                                                    {{ category.description }}
                                                </span>
                                            </div>
                                        </v-ons-list-header>
                                    </v-ons-list>
                                    <!-- We need to set a max-height on the product list to allow the expand/collapse
                                         animation to function. Items are approx 135px tall on the smallest viewport.
                                         Build in some contingency in case some items are expanded to prevent clipping.
                                    -->
                                    <v-ons-list v-bind:style="{'max-height': `${category.items.length * 135 * 2}px`}"
                                                v-if="inner_outlet.collapse_menu_categories == false || `${inner_outlet.id}-${category_index}` == selected_category_index"
                                                v-bind:class="{
                                                    'collapseable': true,
                                                    'collapsed': categories_collapsed[`${inner_outlet.id}-${category_index}`],
                                                }">
                                        <product-menu-list-item
                                                v-for="(product, index) in category.items"
                                                v-show="isNotVoucher(product)"
                                                v-bind:product="product"
                                                v-bind:basket="order.baskets[inner_outlet.id]"
                                                v-bind:truncate_description="product_desc_expand_mode"
                                                v-bind:key="`${inner_outlet.id}-${category.title}-${index}-${product.product_id}`"
                                                v-on:touchstart="buttonActivated($event, product, inner_outlet)"
                                                v-on:touchend="buttonDeactivated($event, product, inner_outlet)"
                                                v-on:touchmove="buttonCancelled()"
                                                v-on:mousedown="buttonActivated($event, product, inner_outlet)"
                                                v-on:mouseup="buttonDeactivated($event, product, inner_outlet)"/>
                                    </v-ons-list>
                                </div>
                            </div>
                        </template>

                        <!-- Vouchers -->
                        <div v-if="filtered_vouchers.length > 0">
                            <div>
                                <v-ons-list>
                                    <v-ons-list-header 
                                            v-on:click="categoryClicked('vouchers', outlet.outlets[0])"
                                            v-bind:class="{
                                               'collapse-toggle': collapse_menu,
                                               'toggle-collapsed': !show_vouchers
                                            }"
                                            class="header-category branded"
                                            ref="vouchers_list"
                                            modifier="chevron">
                                        <div class="header-category-container">
                                            <span class="header-category-text">
                                                {{ filters.pluralise(outlet.allowed_voucher_amount.length, outlet.voucher_product.product_name) }}
                                                ({{ filtered_vouchers.length }})
                                                <svg v-show="global_collapse_menu_categories" height="32px" width="64px" viewBox="0 0 64 32" class="opener-arrow">
                                                  <line x1="1" y1="1" x2="32" y2="30" style="stroke-width:5" />
                                                  <line x1="30" y1="30" x2="63" y2="1" style="stroke-width:5" />
                                                </svg>
                                            </span>
                                            <span class="header-category-description">
                                                <br>
                                                <span v-if="outlet.supports_voucher" data-test-id="txt-voucher-redeem-online">Redeemable in Goodeats and in-store</span>
                                                <span v-else data-test-id="txt-voucher-redeem-instore">Redeemable in-store</span>
                                            </span>
                                        </div>
                                    </v-ons-list-header>
                                </v-ons-list>
                                <v-ons-list v-bind:style="{'max-height': `${outlet.allowed_voucher_amount.length * 135}px`}"
                                            v-if="global_collapse_menu_categories == false || selected_category_index == 'vouchers'"
                                             v-bind:class="{
                                                'collapseable': true,
                                                'collapsed': !show_vouchers && global_collapse_menu_categories == true,
                                              }">
                                    <v-ons-list-item
                                            v-on:click="addVoucherToBasket(voucher, 1)"
                                            v-for="(voucher, voucher_index) in filtered_vouchers"
                                            v-bind:key="voucher_index"
                                            v-bind:class="{ 'product-unavailable': voucher.enabled == false }"
                                            class="list-item-product"
                                            tappable>
                                        <div class="center">
                                            <span class="list-item__title">{{ `${outlet.currency_symbol + voucher.amount} ${outlet.voucher_product.product_name}`}}</span>
                                            <span class="list-item__subtitle">
                                                <template>
                                                    <span v-show="basketInfo.voucher_quantities[`${voucher.amount}_voucher`] > 0" class="label-basket">
                                                        <i class="fa fa-shopping-basket"></i>
                                                        {{ basketInfo.voucher_quantities[`${voucher.amount}_voucher`]}} in basket
                                                    </span>
                                                </template>
                                            </span>
                                        </div>
                                        <div class="right">
                                            <span class="item-price-text">
                                                {{ filters.money(parseFloat(voucher.selling_price), true, outlet.currency_symbol) }}
                                            </span>
                                        </div>
                                    </v-ons-list-item>
                                </v-ons-list>
                            </div>
                        </div>

                        <div class="spacer spacer-menu-list-bottom"></div>

                        <!-- Goodies login button -->
                        <section class="section-vh big-button-container" v-if="app_mode == 'goodies_browse'">
                            <gtc-button class="btn-action branded" v-on:click="app.goodiesLogin()">
                                Login to order
                            </gtc-button>
                        </section>

                        <!-- Checkout button -->
                        <section class="section-vh big-button-container" v-if="app_mode == null"
                                 v-bind:class="{ 'invisible-opacity': !checkout_button_visible }">
                            <router-link v-bind:to="{ name: 'CreateOrder' }" data-test-id="btn-checkout">
                                <gtc-button class="btn-action branded">
                                    Checkout
                                    {{ filters.money(basketInfo.amount.subtotal, true, outlet.currency_symbol) }}
                                </gtc-button>
                            </router-link>
                        </section>
                    </div>

                </template>

            </div>

        </div>

        <v-ons-card class="modal-hints" v-if="seenHintModal == false && this.outlet" data-test-id="cnt-hints">
            <div class="content">
                <div class="modal-hints-container">
                    <v-ons-list>
                        <v-ons-list-item>
                            <div class="left">
                                <i class="fa fa-info" aria-hidden="true"></i>
                            </div>
                            <span class="centre">
                                Hold an item to see more details
                            </span>
                        </v-ons-list-item>
                        <v-ons-list-item v-if="show_hint_modal_payment_request">
                            <span class="left">
                                <i class="fa fa-mobile" aria-hidden="true"></i>
                            </span>
                            <span class="centre">
                                Checkout faster with {{ helpers.paymentRequestName() }}
                            </span>
                        </v-ons-list-item>
                    </v-ons-list>
                    <div class="modal-hints-button-container">
                        <gtc-button class="btn-action branded" data-test-id="btn-hints-dismiss" @click="() => shownHintModal()">
                            Got it
                        </gtc-button>
                    </div>
                </div>
            </div>
        </v-ons-card>

        <v-ons-alert-dialog
                v-bind:title="outlet ? outlet.popup_title : ''"
                v-bind:visible="show_popup && allowPopup"
                v-bind:footer="{ Close: () => show_popup = false }">
            <span class="line-breaks" v-if="outlet">{{ outlet.popup_description }}</span>
        </v-ons-alert-dialog>

        <v-ons-alert-dialog
                v-bind:title="view_product ? view_product.product_name : ''"
                v-bind:visible="view_product != null"
                v-bind:footer="{ Close: () => view_product = null }">
            <div class="product-modal-content" v-if="view_product">
                <img class="product-modal-img" v-bind:src="view_product.image">
                <span v-if="helpers.stringEmpty(view_product.product_desc)" class="empty-text">
                    No description provided
                </span>
                <span v-else class="line-breaks">{{ view_product.product_desc }}</span>
            </div>
        </v-ons-alert-dialog>

        <v-ons-alert-dialog
                data-test-id="dlg-reorder"
                v-if="reorder"
                v-bind:visible="show_reorder"
                v-bind:title="`Reorder from ${this.filters.date(reorder.previous_sale.sales_date_time, false)}`"
                v-bind:footer="{ Close: () => show_reorder = false }">
            <span>
                {{ reorder.eligible_products.length }} of {{ reorder.eligible_products.length + reorder.error_products.length }}
                products added from your previous order. Prices may have changed since your last order.
            </span>
            <span v-show="reorder.error_products.length > 0">
                <br><br>
                The following products could not be added from your previous order:
            </span>
            <ul>
                <li v-for="product in reorder.error_products" :key="product.id">
                    {{ product.quantity }}x {{ product.product_name }}
                    <span v-if="product.modifiers.length > 0">({{ product.modifiers.length }} options)</span>
                    - {{ product.reason }}
                </li>
            </ul>
        </v-ons-alert-dialog>

        <v-ons-alert-dialog
                title="Offers" v-bind:visible.sync="show_promotions_dlg"
                v-bind:footer="{ 'Close': () => this.show_promotions_dlg = false }">
            <p>The following offers will be applied automatically when items are added to your basket.</p>
            <div v-if="selected_outlet">
                <p v-for="promotion in selected_outlet.promotions">
                     <i class="fal fa-money-bill-wave float-left promo-icon" aria-hidden="true"></i>
                    {{ promotion.description }}
                </p>
            </div>
        </v-ons-alert-dialog>

        <v-ons-alert-dialog
                data-test-id="dlg-order-incomplete"
                v-bind:visible.sync="show_order_incomplete_dlg"
                v-bind:footer="{
                    Close: () => this.show_order_incomplete_dlg = false,
                }"
                title="Incomplete order">
            <div class="section-h">
                We were unable to create this order when previously attempted. You can continue to complete your order here.
            </div>
        </v-ons-alert-dialog>

    </v-ons-page>

</template>

<script>
    import { mapGetters, mapMutations, mapActions } from 'vuex'
    import throttle from 'lodash.throttle'
    import { default as debounce } from 'lodash.debounce'
    import Vue from 'vue'
    import VClamp from 'vue-clamp'

    import { default as WhenOutletLoadedMixin } from '../../mixins/whenoutletloaded'
    import { default as BrandingMixin } from '../../mixins/branding'
    import { default as BrowseOnlyMixin } from '../../mixins/browse_only'
    import OpenWarningComponent from '../fragments/open_warning'
    import AllergyWarningListItemComponent from '../fragments/allergy_warning_list_item'
    import ProductMenuListItem from '../fragments/product_menu_list_item'

    export default {

        mixins: [WhenOutletLoadedMixin, BrandingMixin, BrowseOnlyMixin],

        props: [

        ],

        components : {
            'open-warning': OpenWarningComponent,
            'allergy-warning-list-item': AllergyWarningListItemComponent,
            'product-menu-list-item': ProductMenuListItem,
            'vue-clamp': VClamp,
        },

        created() {
        },

        mounted() {

            this.app.analytics.track('viewStore')

            // Debounce search events
            this.$watch('search_query', debounce(function (value) {

                if (value.length == 0)
                    return

                const search_event_metadata = {
                    device_id: this.$store.getters.deviceId,
                }
                if (this.outlet) {
                    search_event_metadata.client_id = this.outlet.client_id
                    search_event_metadata.outlet_is_multivendor = this.outlet.multivendor_controller ? '1' : '0'
                }
                if (this.order) {
                    search_event_metadata.local_order_id = this.order.local_id
                }
                this.app.analytics.track('search', search_event_metadata)

                this.app.trackFbEvent(
                    'Search',
                    {
                        search_string: value
                    }
                )
            }, 2000));

            this.removeBranding()

            this.scroll_handler = throttle((e) => {
                const target = e.originalTarget || e.target
                // Vertical scroll position of the page
                const scroll_y = target.scrollTop

                // Animate header collapse on scroll
                const header = this.$refs['main-toolbar']
                if (header) {
                    const header_max_height = header.parentNode.clientHeight / 4
                    let current_header_height = header_max_height - scroll_y
                    if (current_header_height > 56) { // 56px is the current toolbar height
                        this.show_header_image = true
                        // Check if we can keep scrolling the page, it's used to stop the UI flickering
                        if (scroll_y >= 0 && target.scrollHeight > target.clientHeight + scroll_y) {
                            this.scroll_position = scroll_y
                        }
                    } else {
                        this.show_header_image = false
                    }
                }

                // Set whether the search bar should stick
                const container = this.$refs['scroll-target']
                if (container) {
                    // Vertical distance between the scroll target and the top of the page
                    const scroll_target_position = container.offsetTop
                    // Set the search bar to fixed if we've scrolled past the scroll target
                    this.search_bar_fixed = scroll_y > scroll_target_position
                }
            }, 10)

            // Load menu options from current order
            let fulfillment_type = null
            let display_layout_id = null
            if (this.order.menu_option) {
                fulfillment_type = this.order.menu_option.fulfillment_type
                display_layout_id = this.order.menu_option.display_layout.id
            }
            this.getOutlet(fulfillment_type, display_layout_id)
                .then(() => this.outletLoaded())
                .catch(() => {})
        },

        beforeDestroy(){

            this.removeBranding()
        },

        data () {
            return {
                app: this.$root.$data.app,
                menu_query: '',
                loading: false,
                long_press_delay: 500,
                clicked_timer: null,
                clicked_at: null,
                view_product: null,
                search_bar_fixed: false,
                scroll_handler: null,
                basket_flash: false,
                collapse_menu: true,
                categories_collapsed: {},
                outlets_collapsed: {},
                request_id: 0,
                reorder: null,
                show_order_incomplete_dlg: false,
                show_reorder: false,
                show_popup: false,
                popup_shown: false,
                selected_category_index: null,
                selected_outlet_index: null,
                show_vouchers: false,
                has_header_image: true,
                show_header_image: true,
                scroll_position: 0,
                show_promotions_dlg: false,
                selected_outlet: null,
                menu_option: {
                    fulfillment_type: null,
                    fulfillment_type_name: null,
                    display_layout: null,
                },
                description_collapsed: true,
            }
        },

        methods : {

            ...mapMutations([
                'addProduct',
                'setSidebarOpen',
                'clearOrder',
                'shownHintModal',
                'setPromotions',
                'addVoucher',
                'setMenuOption',
                'clearMenuOption',
                'setOutlet',
                'clearOutlet',
                'removeInvalidProducts',
            ]),

            ...mapActions([
                'refreshPromotions',
            ]),

            getOutlet(fulfillment_type = null, display_layout_id = null) {

                return new Promise((resolve, reject) => {
                    const data = {}
                    if (fulfillment_type)
                        data.fulfillment_type = fulfillment_type
                    if (display_layout_id)
                        data.display_layout_id = display_layout_id

                    return this.app.http.get('outlet/' + this.$route.params.outlet_slug, data)
                        .then(response => {
                            const outlet_data = response.data.outlet
                            this.setOutlet(outlet_data)
                            resolve()
                        })
                        .catch(error => {
                            reject(error)
                            setTimeout(() => {
                                this.$router.push({
                                    name: 'Outlets',
                                    params: {
                                        notify_user: [
                                            this.app.getResponseErrorMessage(error),
                                            { title: 'Unable to load store' }
                                        ]
                                    }
                                })
                            }, 500);

                            // Log if error is not HTTP error
                            if (this.app.errorIsHttp(error) == false) {
                                this.app.logException(new Error('Could not set outlet'), {error})
                            }
                        })
                    })
            },

            addVoucherToBasket(voucher, quantity){

                if (this.browse_only)
                    return this.handleBrowseInteract()

                if (this.outlet.enabled == false)
                    return

                this.addVoucher({ voucher, quantity, outlet: this.outlet })
                this.basketFlash()
            },

            isNotVoucher(product){
                if(this.outlet.voucher_product)
                    return product.product_id != this.outlet.voucher_product.id
                return true
            },

            outletLoaded() {

                this.has_header_image = true

                // Redirect
                const stability = window.env.stability || 'stable'
                const target_stability = this.outlet.is_beta ? 'beta' : 'stable'

                // If wrong stability, redirect
                if (stability != target_stability) {

                    // Check if we have a redirect URL
                    const target_url = window.env.urls[target_stability]
                    if (window.env.urls && target_url) {
                        // Only redirect if target url is different to current URL (to prevent looping)
                        if (target_url != window.location.origin) {
                            window.location = target_url + window.location.pathname + window.location.search
                        }
                    }
                    // Log invalid config
                    else {
                        this.app.logException(new Error('No URL to redirect to for stability'), {
                            target_stability,
                            stability
                        })
                    }
                }

                const current_outlet_slug = this.outlet.slug
                const basket_outlet_slug = this.orderOutletSlug

                if (basket_outlet_slug == null) {
                    console.log('cleared non-actioned order')
                    this.clearOrder()
                }

                this.removeInvalidProducts({ outlet: this.outlet })

                const outlet_changed = basket_outlet_slug != null && current_outlet_slug != basket_outlet_slug

                const next = () => {

                    // Check for URL param which sets the fulfillment type and display layout
                    if (this.presetFulfilmentType) {
                        console.log('loading menu option from preset', this.presetFulfilmentType)

                        this.clearMenuOption()

                        this.$nextTick(() => {
                            // Attempt to set fulfillment type
                            if (this.setFulfillmentType(this.presetFulfilmentType.type)) {

                                // Attempt to set display layout
                                if (this.presetFulfilmentType.display_layout_id) {
                                    const display_layout = this.filtered_display_layouts
                                        .find(dl => dl.id.toLowerCase() == this.presetFulfilmentType.display_layout_id.toLowerCase())
                                    if (display_layout) {
                                        this.setDisplayLayout(display_layout)
                                    } else {
                                        this.setDisplayLayout(null)
                                        this.app.logException(
                                            new Error('Failed to set display layout from URL - not found'),
                                            {
                                                fulfillment_type: this.presetFulfilmentType.type,
                                                display_layout_id: this.presetFulfilmentType.display_layout_id,
                                            }
                                        )
                                    }
                                }
                            }
                            // Fulfillment type not found, record error
                            else {
                                this.clearMenuOption()
                                this.setDefaultMenuOption()
                            }
                        })
                    }
                    // If a fulfillment type and menu are already set (eg from reloading state), check that both are
                    // still available. Also update the display layout with recently loaded data.
                    else if (this.order.menu_option && basket_outlet_slug != null) {
                        console.log('loading menu option from order')

                        const missing_fulfillment_type = this.outlet.order_fulfillment_types.hasOwnProperty(this.order.menu_option.fulfillment_type) == false
                        const missing_display_layout = this.outlet.display_layouts.find(d => d.id == this.order.menu_option.display_layout.id) == null

                        if (missing_fulfillment_type || missing_display_layout) {
                            this.clearOrder()
                        } else {
                            this.setFulfillmentType(this.order.menu_option.fulfillment_type)
                            this.setDisplayLayout(this.filtered_display_layouts.find(d => d.id == this.order.menu_option.display_layout.id))
                        }
                    }
                    // If reorder, attempt to set the same menu and fulfillment type
                    else if (this.$route.params.reorder) {
                        console.log('loading menu option from reorder')

                        this.reorder = Object.assign({}, this.$route.params.reorder)
                        this.$route.params.reorder = null
                        this.show_reorder = true

                        if (this.reorder.fulfillment_type && this.reorder.display_layout_id) {
                            this.setFulfillmentType(this.reorder.fulfillment_type)

                            const display_layout = this.filtered_display_layouts.find(dl => dl.id == this.reorder.display_layout_id)
                            this.setDisplayLayout(display_layout)
                        }
                    }
                    // If no currently selected menu option, set default
                    else {
                        console.log('setting default menu option')
                        this.setDefaultMenuOption()
                    }

                    this.app.trackFbEvent(
                        'PageView',
                        {
                            content_name: 'Menu',
                        }
                    )

                    // Show order incomplete dialog if required
                    if (this.$route.params.in_flight) {
                        this.show_order_incomplete_dlg = true
                    }

                    // Show a message if present dropoff location loaded (only on initial load)
                    if (this.presetFulfilmentType && this.presetFulfilmentType.outlet_slug == this.outlet.slug && !this.order.checkout_info) {
                        const store_name = this.outlet.store_display_name
                        const fulfilment_type = this.presetFulfilmentType.type
                        if (this.outlet.supports_dropoff && fulfilment_type == 'DROPOFF') {
                            const dropoff_point = this.presetFulfilmentType.dropoff_point
                            const dropoff_point_reference = this.presetFulfilmentType.dropoff_point_reference
                            this.$ons.notification.toast(
                                `We've set your location to ${dropoff_point} ${(dropoff_point_reference) ? `- ${dropoff_point_reference}` : ``} at ${store_name}`,
                                { timeout: 4000 }
                            )
                        } else if (fulfilment_type == 'COLLECTION') {
                            const collection_point = this.presetFulfilmentType.collection_point
                            this.$ons.notification.toast(
                                `We've set your fulfilment type to ${fulfilment_type.toLowerCase()} at ${collection_point}`,
                                { timeout: 4000 }
                            )
                        }
                        else {
                            this.$ons.notification.toast(
                                `We've set your fulfilment type to ${fulfilment_type.toLowerCase()}`,
                                { timeout: 4000 }
                            )
                        }
                    }
                }

                // Clear basket if switching stores
                if (outlet_changed) {
                    // Clear immediately when embedded, otherwise prompt user
                    if (this.embed.enabled) {
                        this.clearOrder()
                        next()
                    } else {
                        this.$ons.notification.confirm(
                            `Your basket contains items from another store. You can complete your order in that store or clear your basket and start a new order from ${this.outlet.store_display_name}.`,
                            { title: 'Store changed', buttonLabels: ['Start new order', 'Complete order'] }
                        ).then(result => {
                            if (result == 1) {
                                this.navigateToOutlet(basket_outlet_slug)
                            } else {
                                this.clearOrder()
                                next()
                            }
                        })
                    }
                } else {
                    next()
                }
            },

            productAdd: function(product, outlet, quantity) {

                if (this.outlet.enabled == false)
                    return

                if (this.order.menu_option.display_layout.opening_times_info.can_order_now == false) {
                    const message = 'It is not possible to create an order at this time - please check the store\'s operating hours.'
                    this.$ons.notification.alert(message, { title: 'Sorry' })
                    return
                }

                if (product.is_available == false) {
                    this.$ons.notification.alert(
                        `${product.product_name} is currently unavailable.`,
                        {
                            title: 'Unavailable',
                            buttonLabels: ['Close']
                        },
                    )
                    return
                }

                if (product.variants.length == 0 && product.modifier_sets.length == 0) {

                    if (this.browse_only)
                        return this.handleBrowseInteract()

                    this.addProduct({
                        product,
                        quantity,
                        modifiers: [],
                        root_product_id: product.product_id,
                        outlet,
                    })
                    this.basketFlash()

                    this.app.trackFbEvent(
                        'AddToCart',
                        {
                            'content_name': product.product_name,
                        },
                    )

                } else {
                    this.$router.push({
                        name: 'Product',
                        params: {
                            id: product.product_id,
                            root_product_id: product.product_id,
                            product_outlet: outlet,
                        }
                    })
                }
            },

            buttonActivated(event, product){

                this.clicked_at = (new Date()).getTime()
                this.clicked_timer = setTimeout(() => {
                    this.view_product = product
                }, this.long_press_delay)
            },

            buttonDeactivated(event, product, outlet){
                event.preventDefault()

                if (this.clicked_timer) {
                    clearTimeout(this.clicked_timer)
                    this.clicked_timer = null
                }

                if (this.clicked_at != null) {
                    const time = (new Date()).getTime() - this.clicked_at
                    if (time < this.long_press_delay)
                        this.productAdd(product, outlet, 1)
                }
            },

            buttonCancelled(){
                if (this.clicked_timer) {
                    clearTimeout(this.clicked_timer)
                    this.clicked_timer = null
                }
                this.clicked_at = null
            },

            basketFlash(){
                this.basket_flash = true
                setTimeout(() => this.basket_flash = false, 300)
            },

            sidebarToggle(){
                this.setSidebarOpen(true)
            },

            listScrolled(e){
                if (this.scroll_handler == null)
                    return

                return this.scroll_handler(e)
            },

            categoryClicked(category_index, outlet) {

                // Don't expand/collapse if setting is disabled
                if (outlet && outlet.collapse_menu_categories == false)
                    return

                if (category_index == 'vouchers') {
                    const opening = this.show_vouchers == false
                    if (opening) {
                        this.selected_category_index = 'vouchers'
                        Object.entries(this.categories_collapsed).forEach(([key, value]) => {
                            Vue.set(this.categories_collapsed, key, true)
                        })
                        this.show_vouchers = true
                        this.$nextTick(() => {
                            this.$refs['vouchers_list'].$el.scrollIntoView({behavior: 'smooth'})
                        })
                    } else {
                        this.show_vouchers = false
                    }
                    return
                }

                this.selected_category_index = `${outlet.id}-${category_index}`
                const new_state = !this.categories_collapsed[`${outlet.id}-${category_index}`]
                const opening = new_state == false

                // If opening, open this category and collapse all others
                if (opening) {
                    Object.entries(this.categories_collapsed).forEach(([index, value]) => {
                        // Don't open close outlets belonging to other outlets. This will cause problems if the other
                        // outlets contain menus that don't collapse.
                        if (index.startsWith(outlet.id)) {
                            Vue.set(this.categories_collapsed, index, index != this.selected_category_index)
                        }
                    })
                    // Scroll into view
                    this.$nextTick(() => {
                        let index = category_index == 0 ? category_index : category_index - 1
                        this.$refs[`category_${outlet.id}_${index}`][0].$el.scrollIntoView({ behavior: 'smooth'})
                    })
                }
                // If closing, collapse self
                else {
                    const key = `${outlet.id}-${category_index}`
                    Vue.set(this.categories_collapsed, key, true)
                }
            },

            outletClicked(outlet) {

                if (this.outlet.outlets.length == 1)
                    return

                this.selected_outlet_index = outlet.id
                const new_state = !this.outlets_collapsed[outlet.id]
                const opening = new_state == false

                // If opening, open this category and collapse all others
                if (opening) {
                    Object.entries(this.outlets_collapsed).forEach(([index, value]) => {
                        Vue.set(this.outlets_collapsed, index, index != this.selected_outlet_index)
                    })
                    // Scroll into view
                    this.$nextTick(() => {
                        //let index = category_index == 0 ? category_index : category_index - 1
                        //this.$refs[`category_${outlet.id}_${index}`][0].$el.scrollIntoView({ behavior: 'smooth'})
                    })
                }
                // If closing, collapse self
                else {
                    const key = outlet.id
                    Vue.set(this.outlets_collapsed, key, true)
                }
            },

            setDefaultMenuOption(){
                // If we're not loading an existing menu option, set defaults where there are no choices
                if (this.order.menu_option == null) {
                    // Set the fulfillment type if there is only one
                    if (Object.keys(this.outlet.order_fulfillment_types).length == 1) {
                        this.setFulfillmentType(Object.keys(this.outlet.order_fulfillment_types)[0])
                    }
                } else {
                    console.log('attempted to reset menu option but menu option is populated')
                }
            },

            setFulfillmentType(id){

                id = id.toUpperCase()

                if (this.outlet.order_fulfillment_types.hasOwnProperty(id) == false) {
                    console.error(`requested fulfillment type ${id} not present`)
                    return false
                }

                this.menu_option.fulfillment_type = id
                this.menu_option.fulfillment_type_name = id == 'DROPOFF' ? this.outlet.dropoff_label : this.outlet.order_fulfillment_types[id]
                this.menu_option.display_layout = null

                if (this.filtered_display_layouts.length == 1)
                    this.setDisplayLayout(this.filtered_display_layouts[0])

                return true
            },

            showMenu() {

                // Set menu option in store
                this.setMenuOption({
                    fulfillment_type: this.menu_option.fulfillment_type,
                    fulfillment_type_name: this.menu_option.fulfillment_type_name,
                    display_layout: this.menu_option.display_layout,
                })

                // Collapse description
                this.description_collapsed = false

                // Scroll down to menu only if manually selected
                if (this.has_multiple_fulfillment_types) {
                    this.$nextTick(() => {
                        const scroll_target = this.$refs['scroll-target']
                        if (scroll_target) {
                            scroll_target.scrollIntoView({behavior: 'smooth'})
                        }
                    })
                }

                // Setup collapsed outlets
                const outlet_collapsed_default = this.outlet.outlets.length > 1
                this.outlet.outlets.forEach(outlet => {
                    Vue.set(this.outlets_collapsed, outlet.id, outlet_collapsed_default)
                })

                // Setup collapsed categories. Either expand or collapse all by default.
                this.categories_collapsed = {}
                this.outlet.outlets.forEach(outlet => {
                    outlet.menu.forEach((category, index) => {
                        Vue.set(this.categories_collapsed, `${outlet.id}-${index}`, outlet.collapse_menu_categories)
                    })
                })
                this.show_vouchers = this.global_collapse_menu_categories == false

                // Show popup
                if (this.outlet.enable_popup &&
                    (this.helpers.stringEmpty(this.outlet.popup_title) == false ||
                    this.helpers.stringEmpty(this.outlet.popup_description) == false) &&
                    this.popup_shown == false &&
                    this.show_reorder == false) {

                    setTimeout(() => {
                            this.show_popup = true
                            this.popup_shown = true
                        },
                        3 * 1000
                    )
                }
            },

            changeMenuOption() {

                const message = 'Changing the order type will reset your basket because some items may not be available.'
                this.$ons.notification.confirm(message, {
                        title: 'Confirm change order type',
                        buttonLabels: [
                            `Cancel`,
                            `Change and reset`,
                        ],
                    })
                    .then((button) => {

                        // Cancelling
                        if (button != 1)
                            return

                        this.clearMenuOption()

                        this.description_collapsed = true

                        this.$nextTick(() => {
                            this.setDefaultMenuOption()
                        })

                    })
                    .catch((error) => {
                        this.app.logException(new Error('Failed to change menu option.'), { error })
                    })
            },

            resetMenuOption(){
                this.menu_option.fulfillment_type = null
                this.menu_option.fulfillment_type_name = null
                this.menu_option.display_layout = null
            },

            setDisplayLayout(display_layout){

                if (display_layout == null) {
                    this.menu_option.display_layout = null
                    return
                }

                // Fetch outlet details. Even if the display layout hasn't changed, the fulfillment type may have
                // (which can affect pricing).
                this.getOutlet(this.menu_option.fulfillment_type, display_layout.id)
                    .then(() => {
                        this.menu_option.display_layout = display_layout
                        this.showMenu()
                    })
                    .catch(() => {})
            },

            navigateToOutlet(outlet_slug) {
                this.$router.push({ name: 'Menu', params: { outlet_slug } })
                this.clearOutlet()
                this.getOutlet()
                    .then(() => this.outletLoaded())
                    .catch(() => {})
            },

            showPromotions(outlet) {
                this.selected_outlet = outlet
                this.show_promotions_dlg = true
            },
        },

        computed: {

            ...mapGetters([
                'order',
                'basketInfo',
                'outlet',
                'embed',
                'orderOutletSlug',
                'seenHintModal',
                'allowPopup',
                'presetFulfilmentType',
                'app_mode',
                'browse_only',
                'orderLoadedDirectly'
            ]),

            checkout_button_visible: function(){
                return this.basketInfo.has_items
            },

            show_loading: function(){
                return this.outlet == null
            },

            search_query: function(){
                return this.menu_query.toLowerCase().trim()
            },

            filtered_menu: function(){

                if (this.outlet == null)
                    return {}

                const query = this.search_query

                const data = this.outlet.outlets
                    .map(outlet => {
                        return {
                            outlet_id: outlet.id,
                            categories: outlet.menu.map(category => {
                                const new_category = Object.assign({}, category)

                                if (query.length > 0) {
                                    // If category name in query, include entire category
                                    if (category.title.toLowerCase().includes(query)) {
                                        new_category.items = category.items
                                    }
                                    // Otherwise search product names
                                    else {
                                        new_category.items = new_category.items
                                            .filter(product => product.product_name.toLowerCase().includes(query))
                                    }
                                }

                                return new_category
                            })
                        }
                    })

                const out = {}
                data.forEach(entry => out[entry.outlet_id] = entry.categories)
                return out
            },

            filtered_vouchers: function(){

                if (this.outlet == null)
                    return []

                if (this.outlet.enable_voucher_selling == false)
                    return []

                const query = this.search_query

                // If no search or search term appears in voucher name, return all
                if (query.length == 0 || this.outlet.voucher_product.product_name.toLowerCase().includes(query))
                    return this.outlet.allowed_voucher_amount

                // Filter specific vouchers
                return this.outlet.allowed_voucher_amount.filter(voucher => {
                    return voucher.amount.toString().toLowerCase().includes(query)
                })
            },

            menu_list_top_spacer_height: function () {
                const fixed_warning_bar = this.search_bar_fixed &&
                    this.outlet.opening_times_info.is_open == false

                const sticky_container = this.$refs['sticky-container']

                // Get the total height we need to fill under the floating element. This will either be the height
                // of the warning message or sticky header.
                let offset = 0
                if (fixed_warning_bar)
                    offset += 41
                if (this.search_bar_fixed)
                    offset += sticky_container ? sticky_container.clientHeight : 125

                return offset
            },

            sticky_container_style: function() {
                const css = {}
                if (this.search_bar_fixed) {
                    css['position'] = 'fixed'
                    css['top'] = '55px'
                    css['left'] = '0px'
                    css['z-index'] = 6
                }
                return css
            },

            show_hint_modal_payment_request: function() {
                if (this.helpers.paymentRequestName(false) == null)
                    return false

                return this.outlet_supports_payment_request
            },

            display_layouts: function () {
                if (this.outlet == null)
                    return []

                return this.outlet.display_layouts
            },

            filtered_display_layouts() {

                if (this.menu_option.fulfillment_type == null)
                    return []

                const set_opening_times = (s) => {
                    s.opening_times_info = s.opening_times[this.menu_option.fulfillment_type].opening_times_info
                    return s
                }

                // Get list of menus that the user can currently order from
                let filtered_list = this.display_layouts
                    .filter(s => s.fulfillment_types.includes(this.menu_option.fulfillment_type))
                    .map(set_opening_times)
                    .filter(s => s.opening_times_info.can_order_now)
                    .sort((a, b) => {
                        if (a.opening_times_info.is_open != b.opening_times_info.is_open)
                            return a.opening_times_info.is_open ? -1 : 1

                        return a.display_name < b.display_name ? -1 : 1
                    })

                // If filtered list is empty (no applicable menus), return the default layout
                if (filtered_list.length == 0)
                    filtered_list = [this.outlet.display_layouts.find(s => s.id == 'DEFAULT')].map(set_opening_times)

                return filtered_list
            },

            has_multiple_fulfillment_types() {
                return this.outlet && Object.values(this.outlet.order_fulfillment_types).length > 1
            },

            has_multiple_menus: function() {
                return this.display_layouts.filter(s => s.can_order_now).length > 1
            },

            show_menu_option_bar: function() {
                return this.order &&
                    this.order.menu_option != null &&
                    (this.has_multiple_fulfillment_types || this.has_multiple_menus) &&
                    this.outlet &&
                    this.outlet.enabled
            },

            outlet_tags: function() {
                if (this.outlet == null)
                    return []

                const tags = this.outlet.tags.map(t => this.filters.capitalise(t.name))

                if (this.outlet.eo2ho_scheme_supported)
                    tags.push('Eat Out to Help Out')

                return tags
            },

            global_collapse_menu_categories(){

                if (this.outlet && this.outlet.outlets[0]) {
                    return this.outlet.outlets[0].collapse_menu_categories
                }

                return true
            },

            product_desc_expand_mode() {
                return this.outlet && window.env.product_expand_client_ids.includes(this.outlet.client_id)
                    ? 'expand' : true
            }
        },

        watch: {

            'order.menu_option': {
                handler: function(new_value, old_value) {
                    // If order menu option has changed, clear menu option in this page to reset selector state
                    if (new_value == null)
                        this.resetMenuOption()
                },
                sync: true,
            },

            view_product: function(value) {

                if (value == null)
                    return

                this.app.trackFbEvent(
                    'ViewContent',
                    {
                        content_name: `Product - ${value.product_name}`,
                    }
                )
            },

            show_promotions_dlg: function(value) {

                if (value == false)
                    return

                this.app.trackFbEvent(
                    'ViewContent',
                    {
                        content_name: 'Promotions',
                    }
                )
            }
        }
    }
</script>

<style scoped>
    /* Required for WebKit for the page content to appear. Doesn't affect other engines - strange. */
    .page__content {
        z-index: 1;
    }

    .outlet-info-btns {
        margin-bottom: 10px;
    }

    .outlet-container div {
        text-align: center;
        display: block;
    }

    .product-modal-content {
        max-height: 65vh;
        overflow-y: auto;
    }

    .product-modal-content img {
        width: 100%;
        max-width: 300px;
        margin: 0px auto 20px;
        display: block;
    }

    .spacer {
        width: 100%;
    }

    .spacer.spacer-menu-list-bottom {
        height: 70px;
    }

    .sticky-container {
        width: 100%;
    }

    .invisible-opacity {
        opacity: 0;
        pointer-events: none;
    }

    .list-item__center {
        min-width: 100px;
    }

    .modal-hints {
        position: fixed;
        left: 0px;
        right: 0px;
        bottom: 0px;
        margin: 0px;
        z-index: 1500;
        background: white;
    }

    .modal-hints-container {
        display: flex;
        flex-direction: row;
    }

    .modal-hints-button-container {
        position: relative;
    }

    .modal-hints-container ons-list {
        flex: 1;
        margin-right: 5px;
    }

    .modal-hints-container ons-list-item {
        padding: 0px;
    }

    .modal-hints-container ons-list .left {
        min-width: 20px;
        padding: 0px;
        font-size: 150%;
        text-align: center;
    }

    @media (min-width: 480px) {
        .modal-hints {
            left: auto;
            right: 15px;
            bottom: 15px;
        }
    }

    .modal-hints ons-button {
        top: 50%;
        transform: translateY(-50%);
    }

    .header-category {
        background-color: white;
        padding: 0px;
    }

    .header-category-container {
        margin-top: 15px;
        margin-bottom: 15px;
        padding-left: 15px;
        padding-right: 0px;
        border-left: var(--global-goodtill-green) solid 3px;
    }

    .header-category-text {
        font-weight: bold;
    }

    .header-category-description {
        margin-top: 5px;
        font-size: 14px;
    }

    .opener-arrow {
        float: right;
        height: 10px;
        margin-top: 7px;
        stroke: #333;
        transform: rotate(-180deg);
        transition: transform 150ms ease;
    }

    .toggle-collapsed .opener-arrow {
        transform: rotate(0deg);
    }

    .collapse-toggle {
        cursor: pointer;
    }

    .collapsed {
        max-height: 0px !important;
    }

    .collapseable {
        overflow: hidden;
        transition: max-height 0.2s ease-out;
    }

    .content-margin {
        margin-top: calc(100% / 4) !important;
        -webkit-transition: margin-top 0.15s linear;
        transition: margin-top 0.15s linear;
    }

    .allergy-warning { 
        margin: 10px 8px 5px;
    }

    .outlet-name-header {
        font-size: 20px;
        color: #181d1e;
        font-weight: bold;
        margin-top: 75px;
    }

    .outlet-info-btn > div:nth-child(2) {
        padding-right: 5px;
    }

    .outlet-info-btn > div:nth-child(3) {
        padding-left: 5px;
    }

    .promo-icon {
        margin-right: 5px;
        float: left;
    }

    .icon-bar > i {
        color: #4a4c4c;
    }

    .txt-ordering {
        margin-top: 25px;
    }

    .prompt-multivendor {
        text-align: center;
        margin-top: 15px;
        margin-bottom: 10px;
    }

    .prompt-multivendor > * {
        margin-top: 10px;
    }
</style>

<style>
    .menu-search {
        margin-top: 10px;
    }

    .sticky-container-stuck .header-alert {
        border-radius: 0px;
    }

    .sticky-container-stuck .menu-search {
        margin-top: 0px;
    }

   .fulfillment-type-container {
        margin: 5px auto 0px auto;
        text-align: center;
   }

    .fulfillment-type-container {
        display: flex;
        justify-content: center;
    }

    .fulfillment-type-container > .fulfillment-btn {
        margin: 0px;
    }

    .fulfillment-type-container .fulfillment-btn:nth-child(2) {
        margin: 0px 15px;
    }

    .fulfillment-type-container .button {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 5px;
        cursor: pointer;
    }

    .fulfillment-type-container .button i {
        display: block;
        margin-top: 10px;
        font-size: 150%;
    }

    .fulfillment-btn {
        width: 95px;
        height: 90px;
        background-color: #E1E1E1;
        border-radius: var(--global-border-radius);
        cursor: pointer;
    }

    .fulfillment-btn.active {
        background-color: var(--global-goodtill-green);
    }

    .fulfillment-btn > div {
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        background-color: white;
        margin: 1px;
        border-radius: 5px;
    }

    .fulfillment-btn > div > svg {
        position: relative;
        top: 0px;
    }

    .fulfillment-btn > div > span{
        width: 14px;
        height: 14px;
        background: #E1E1E1;
        display: block;
        position: relative;
        top: 8px;
        left: 8px;
        border-radius: 100%;
        color: white;
        font-size: 10px;
        text-align: center;
        line-height: 17px;
    }

    .fulfillment-btn.active > div > span{
        background: #00dbb4;
    }

    .fulfillment-btn > div > span > i {
        visibility: hidden;
    }

    .fulfillment-btn.active > div > span > i {
        visibility: visible;
    }

    .header-alert-service {
        font-size: var(--global-font-size-med);
    }
</style>



// WEBPACK FOOTER //
// src/js/components/order/menu.vue